import {
  DSDialogPrimaryMessage,
  DSDialogSecondaryMessage,
} from '@elliemae/ds-dialog';
import Grid from '@elliemae/ds-grid';
import { WarningTriangle } from '@elliemae/ds-icons';
import { DecisionDialog } from '@frontend/elliemae-helpers';

export const PendingAdjustmentsDialog = ({
  isOpen,
  handleClose,
  onAffirmation,
}: {
  isOpen: boolean;
  handleClose: () => void;
  onAffirmation: () => void;
}) => {
  return (
    <DecisionDialog
      isOpen={isOpen}
      toggleDialog={handleClose}
      onAffirmation={onAffirmation}
      affirmationButtonLabel="Continue"
      denialButtonLabel="Stay"
      onClose={handleClose}
    >
      <Grid
        padding="10px"
        justifyItems="center"
        alignItems="center"
        height="100%"
      >
        <WarningTriangle size="xxl" color={['warning', '900']} />
        <Grid margin="10px 0px 10px 0px">
          <DSDialogPrimaryMessage>
            Unsaved changes will be lost
          </DSDialogPrimaryMessage>
        </Grid>
        <DSDialogSecondaryMessage>
          <Grid justifyContent="center">
            Are you sure you want to leave this page?
          </Grid>
        </DSDialogSecondaryMessage>
      </Grid>
    </DecisionDialog>
  );
};
